var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type
    ? _c("span", { staticClass: "exists-error" }, [
        _vm._v(
          "\n  Введённый " +
            _vm._s(_vm.text) +
            " существует в системе. Попробуйте "
        ),
        _c(
          "a",
          {
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("login")
              }
            }
          },
          [_vm._v("авторизоваться")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }